export default __webpack_public_path__ + "static/media/003-lamp.b280ad10.svg";